module.exports = __webpack_public_path__ + "3a6137e8ee9a4711e81cc136191d232d.fbx";